import React, { useState, useEffect } from "react";
import AppLayout from "./Components/AppLayout";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactGA from "react-ga";
import mixpanel from "mixpanel-browser";
import { Provider } from "react-redux";
import { store } from "./Store";
import { onAuthStateChanged, signInWithCustomToken } from "firebase/auth";
import { auth } from "../src/Components/firebase/firebase";
import { AuthProvider } from "./AuthContext";
import { BrowserRouter } from "react-router-dom";
import PrivateRoute from "../src/PrivateRoute";
import { Switch } from "react-router-dom";
import Loader from "./Components/Loader";
import { Urls } from "./Urls";
import { UserDataProvider } from "./UserContext";
import { UserDetailsProvider } from "./UserDetailsContext";
import { EditbleEmailsProvider } from "./EditbleEmailsContext";
import Axios from "axios";

// Import CSS files for styling various components
import "./Components/AdminPage/Dashboard/liveDashboard.css";
import "./Components/AdminPage/Dashboard/OverallDashboard.css";
import "./Components/AdvancedAuction/AdvancedAuction.css";
import "./Components/AdvancedAuction/AuctionDashboard/LiveDashboard.css";
import "./Components/AdvancedAuction/AuctionDashboard/OverallSummary.css";
import "./Components/AnalysisNow/AnalysisNow.css";
import "./Components/Auction/Auction.css";
import "./Components/Auction/ModalBox/modal.css";
import "./Components/AuctionShortlist/AuctionShortlist.css";
import "./Components/Body/body.css";
import "./Components/CompanySelect/Company.css";
import "./Components/Documents/Documents.css";
import "./Components/Lanes/Lane.css";
import "./Components/Lanes/Filters/filters.css";
import "./Components/Loader/Loader.css";
import "./Components/ModalBox/modal.css";
import "./Components/Notifications/Notifications.css";
import "./Components/Overlay/Overlay.css";
import "./Components/Schedule/Schedule.css";
// import './Components/Shortlist/shortlist.css'
import "./Components/ToolTip/modalBox.css";
// import './Components/TransporterClientScreen/TransporterDetailsBody/style.css'
// import './Components/TransporterClientScreen/TransporterDetailsBody/AboutUs/AboutUs.css'
// import './Components/TransporterClientScreen/TransporterDetailsBody/AcceptableTerms/AcceptableTerms.css'
// import './Components/TransporterClientScreen/TransporterDetailsBody/AdditionalDetails/AdditionalDetails.css'
// import './Components/TransporterClientScreen/TransporterDetailsBody/AreaOfOperations/AreaOfOperations.css'
// import './Components/TransporterClientScreen/TransporterDetailsBody/AssetDetailsForExport/AssetDetailsExport.css'
// import './Components/TransporterClientScreen/TransporterDetailsBody/BankDetails/BankDetails.css'
// import './Components/TransporterClientScreen/TransporterDetailsBody/Contact/c.css'
// import './Components/TransporterClientScreen/TransporterDetailsBody/Contact/contact.css'
import "./Components/TransporterClientScreen/TransporterDetailsBody/Contact/ContactCard.css";
// import './Components/TransporterClientScreen/TransporterDetailsBody/Contact copy/c.css'
// import './Components/TransporterClientScreen/TransporterDetailsBody/Contact copy/contact.css'
// import './Components/TransporterClientScreen/TransporterDetailsBody/Contact copy/ContactCard.css'
// import './Components/TransporterClientScreen/TransporterDetailsBody/Customers/Customers.css'
// import './Components/TransporterClientScreen/TransporterDetailsBody/GSTDetails/GSTDetails.css'
// import './Components/TransporterClientScreen/TransporterDetailsBody/IndustryServed/IndustryServed.css'
// import './Components/TransporterClientScreen/TransporterDetailsBody/KeyFocusArea/KeyFocusArea.css'
// import './Components/TransporterClientScreen/TransporterDetailsBody/LicensesAndCertifications/Licenses.css'
// import './Components/TransporterClientScreen/TransporterDetailsBody/ManPower/ManPower.css'
// import './Components/TransporterClientScreen/TransporterDetailsBody/Map/map.css'
// import './Components/TransporterClientScreen/TransporterDetailsBody/Other/Other.css'
// import './Components/TransporterClientScreen/TransporterDetailsBody/Profile/profile.css'
// import './Components/TransporterClientScreen/TransporterDetailsBody/Profile/profile1.css'
// import './Components/TransporterClientScreen/TransporterDetailsBody/ShipmentMethod/ShipmentTrackingMethod.css'
// import './Components/TransporterClientScreen/TransporterDetailsBody/TMSExperience/TmsExperienceStyles.css'
// import './Components/TransporterClientScreen/TransporterDetailsBody/TruckAssestsDetails/TruckAssetDetails.css'
// import './Components/TransporterClientScreen/TransporterDetailsBody/ValueAddedServices/ValueAddedServices.css'
// import './Components/TransporterClientScreen/TransporterDetailsBody/Warehousing/Warehousing.css'
// import "./Components/UploadsList/UploadsList.css";
import "./Content/css/react-datepicker.css";
import { CompanyDataProvider } from "./CompanyProfileContext";
import { CompanyDetailsProvider } from "./CompanyDetailsContext";
import { MyCompanyProfileDetailsProvider } from "./MyCompanyProfileContext";
import { SidebarProvider } from "./SidebarContext";
import { tpmpAuth } from "./Components/firebase/firebaseRealtime";
import axios from "./Axios";

// Initialize Google Analytics and Mixpanel with respective IDs
ReactGA.initialize(Urls.gaId);
mixpanel.init(Urls.mixpanelId);

const App = () => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [tpmpTokenAcquired, setTpmpTokenAcquired] = useState(false);

  const isValidFirebaseCustomToken = (token) => {
    if (!token || typeof token !== "string") return false;
    const parts = token.split(".");
    return parts.length === 3 && parts.every((p) => p.length > 0);
  };

  useEffect(() => {
    setLoading(true);
    // Extract 'id' and 'auction' parameters from the URL
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    const auction = queryParams.get("auction");
    const screen = queryParams.get("screen"); // e.g., 'analyzeNow', 'documents'
    const procurementId = queryParams.get("procurementId");

    // Check authentication state changes
    onAuthStateChanged(auth, async (user) => {
      if (id !== null && id !== undefined && id !== "") {
        // If 'id' is present, get Firebase token and sign in with custom token
        axios
          .get(`${Urls.firebase_token}&uid=${id}`)
          .then((res) => {
            signInWithCustomToken(auth, res.data.token)
              .then((userCredential) => {
                setCurrentUser(userCredential.user); // Set current user and store necessary information in sessionStorage
                sessionStorage.setItem("uid", id);
                sessionStorage.setItem(
                  "displayName",
                  userCredential.user.displayName
                );
                setLoading(false);

                // Redirect to '/auction' if 'auction' parameter is 'true'
                if (auction === "true" || auction === "auction") {
                  window.location.href = "/auction";
                } else if (screen === "analyzeNow" && procurementId) {
                  window.location.href = `/analyzeNow/${procurementId}`;
                }
              })
              .catch((error) => {
                console.log(error);
                setLoading(false);
              });
          })
          .catch((err) => {
            console.log(err);
            setLoading(false);
          });
      } else if (user) {
        // If user is authenticated, set current user and store necessary information in sessionStorage
        setCurrentUser(user);
        // sessionStorage.setItem("accessToken", user.accessToken);
        sessionStorage.setItem("uid", user.uid);
        sessionStorage.setItem("displayName", user.displayName);
        setLoading(false);
      } else {
        // Redirect to client-side login if no 'id' and user is not authenticated
        window.location.href = `${Urls.clientSideLogin}`;
        setLoading(false);
      }
    });

    // Fetch and store client's IP address in sessionStorage
    Axios.get("https://api.ipify.org?format=json").then((res) =>
      sessionStorage.setItem("ClientIP", res.data.ip)
    );
  }, []);
  //creating new token for client so that it can access TPMP auction data in real time
  useEffect(() => {
    if (!currentUser || tpmpTokenAcquired) return;
    const loginToTPMP = async () => {
      try {
        const resp = await axios.post(`${Urls.auctionlorri1}/customToken`);
        const newCustomToken = resp?.data?.token;
        if (!isValidFirebaseCustomToken(newCustomToken)) {
          // console.error("Invalid TPMP custom token");
          toast.error("Invalid TPMP custom token");
          return;
        }

        await signInWithCustomToken(tpmpAuth, newCustomToken);
        // console.log("TPMP signed in successfully");
        setTpmpTokenAcquired(true);
      } catch (err) {
        console.error("Error logging into TPMP:", err);
      }
    };
    loginToTPMP();
  }, [currentUser, tpmpTokenAcquired]);

  return (
    <>
      <ToastContainer />
      {loading ? (
        <Loader show={loading} />
      ) : (
        <SidebarProvider>
          <BrowserRouter>
            <AuthProvider value={{ currentUser }}>
              {!auth?.currentUser?.getIdToken() ? (
                <>
                  <Switch>
                    {/* Add routes for authentication here if needed */}
                  </Switch>
                </>
              ) : (
                <>
                  <PrivateRoute>
                    <UserDetailsProvider>
                      <UserDataProvider>
                        <CompanyDetailsProvider>
                          <MyCompanyProfileDetailsProvider>
                            <EditbleEmailsProvider>
                              <CompanyDataProvider>
                                <Provider store={store}>
                                  <AppLayout />
                                </Provider>
                              </CompanyDataProvider>
                            </EditbleEmailsProvider>
                          </MyCompanyProfileDetailsProvider>
                        </CompanyDetailsProvider>
                      </UserDataProvider>
                    </UserDetailsProvider>
                  </PrivateRoute>
                </>
              )}
            </AuthProvider>
          </BrowserRouter>
        </SidebarProvider>
      )}
    </>
  );
};

export default App;
